
/**
 * 認証不要ルート用
 * @see https://github.com/sewii/Yokumiru/issues/581
 */

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')
window.Vue = require('vue')

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueRouter from 'vue-router'
window.Vue.use(VueRouter)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.moment = require('moment')

// イベントバス
window.bus = new Vue()


/** ==========================================================================
 * 患者 関連コンポーネント
 * ========================================================================== */
// ナビゲーションバー
Vue.component('nav-bar', require('./components/user/NavBar').default)

// ディープリンクのハンドリング
Vue.component('user-deeplink-handle', require('./components/user/UserDeeplinkHandle').default)

// 会員ログイン
Vue.component('user-login', require('./components/user/UserLogin').default)

// 会員登録
Vue.component('user-signup', require('./components/user/UserSignup').default)

// 会員登録ステップ
Vue.component('user-signup-step', require('./components/user/UserSignupStep').default)

// 会員登録（団体利用アカウント発行）
Vue.component('user-signup-group', require('./components/user/UserSignupGroup').default)

// 会員仮登録完了（メールアドレス）
Vue.component('user-register-provisional-complete', require('./components/user/UserRegisterProvisionalComplete').default)

// 会員登録
Vue.component('user-register', require('./components/user/UserRegister').default)

// 会員登録完了
Vue.component('user-register-complete', require('./components/user/UserRegisterComplete').default)

// formrun連携
Vue.component('formrun-association', require('./components/user/FormrunAssociation').default)

/** ==========================================================================
 * 共通コンポーネント
 * ========================================================================== */
// 設定ステートマッピング
Vue.component('config-state', require('./components/common/vuex/ConfigState').default)

// アラート
Vue.component('alert', require('./components/common/Alert').default)

// 特定のケースで使用されるアラート
Vue.component('case-alert', require('./components/common/CaseAlert').default)

// タイマー
Vue.component('consultation-timer', require('./components/common/ConsultationTimer').default)

// ヘッダー用タイムゾーン表示
Vue.component('timezone', require('./components/common/Timezone').default)
